import { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import GradientButton from "../GradientButton";

const StyledTransferAssetModal = styled.dialog`
    width: 350px;
    height: 270px;
    border-radius: 35px;
    background-color: #1C1C1C;
    border-width: 0px;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    
    &[open] {
        display: flex;
    }

    &::backdrop {
        background-color: #00000090;
    }

    #title {
        color: #FFFFFF;
        font-size: 22px;
        margin: 0px 0px 10px 0px;
    }

    #error-message {
        color: #FFFFFF;
        font-size: 18px;
        margin: 0px;
        text-align: center;
        margin: 10px 0px 0px 0px;
    }

    #asset-image-title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 180px;
    }

    #quantity-container {
        width: 120px;
        height: 35px;
        background: #060E06;
        border-radius: 10px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    #go-back-button {
        background: linear-gradient(#38EF7D, #11998E);
        height: 40px;
        width: 150px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        margin-top: 20px;
    }

    .quantity-controller {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 22px;
    }

    #quantity-display {
        color: #FFFFFF;
        font-size: 22px;
    }
`;

const ResultAssetTransfer = forwardRef(function ResultAssetTransfer({ errorMessage, isSuccess }, ref){
    const modalRef = useRef();

    useImperativeHandle(ref, ()=>{
        return {
            open: open,
            close: close,
        };
    });

    function open(){
        modalRef.current.showModal();
    }

    function close(){
        window.location.reload();
    }

    return (
        <StyledTransferAssetModal ref={modalRef}>
            <p id="title">{isSuccess ? "Success" : "Opps!"}</p>
            {
                isSuccess ?
                    <svg height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#000000">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                        <g id="SVGRepo_iconCarrier"> <polygon fill="#38ef7d" points="47.222,263.447 0,310.669 149.961,460.631 172.222,413.408 149.961,366.186 "/> <polygon fill="#11998e" points="464.778,51.369 149.961,366.186 149.961,460.631 512,98.592 "/> </g>
                    </svg>
                :
                    <svg height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#000000">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                        <g id="SVGRepo_iconCarrier"> <path fill="#38ef7d" d="M0,256c0,141.384,114.615,256,256,256l22.261-256L256,0C114.615,0,0,114.615,0,256z"/> <path fill="#11998e" d="M256,0v512c141.384,0,256-114.616,256-256S397.384,0,256,0z"/> <polygon fill="#FFFFFF" points="161.555,114.333 114.333,161.555 208.778,256 114.333,350.445 161.555,397.667 256,303.222 278.261,256 256,208.778 "/> <polygon fill="#fff4e0" points="397.667,161.555 350.445,114.333 256,208.778 256,303.222 350.445,397.667 397.667,350.445 303.222,256 "/> </g>
                    </svg>
            }            
            <p id="error-message">{ errorMessage ?? 'Something went wrong.'}</p>           
            <GradientButton onTap={close} text={'Go Back'}></GradientButton>
        </StyledTransferAssetModal>
    );
});

export default ResultAssetTransfer;